import { generateLazadaAuthUrl } from 'services/api/admin';

const DIVIDER = '_';
const getLazadaAuthUrl = async () => {
  return generateLazadaAuthUrl().then((resp) => {
    const {
      data: {
        data: { authUrl, redirectSign, timestamp },
      },
    } = resp;
    const base = window.location.origin;
    const info = [redirectSign, timestamp].join(DIVIDER);
    const url = `${authUrl}${encodeURIComponent(`${base}/#/${info}/lazadaauthcallback`)}`;
    return url;
  });
};

export const infoStrParser = (str?: string) => {
  if (!str) {
    return null;
  }
  const [redirectSign, timestamp] = str.split(DIVIDER);
  return {
    redirectSign,
    timestamp,
  };
};
export default getLazadaAuthUrl;
